module.exports = __webpack_public_path__ + "static/media/noShiftScheduled.30b36666.svg";